export default __webpack_public_path__ + "static/media/Path 303.a4a0b27f.svg";